import { PodcastHistory } from '@/modules/player/components/history';
import { withMotion } from '../hoc/with-motion';


const AnimatedPage = withMotion(PodcastHistory);

export const roles: string[] = [];
export const path = '/player/history';
export const element = <AnimatedPage />